export const PRIMARY_LABEL_TEST_ID = 'primary-label';

export const PRICE = 'price';
export const PREVIOUS_PRICE = 'previous-price';
